import { minhaCarteira } from '@constants/URL'
import con from '@services/connection'
import store from '@state/store'
import { BLACK_LIST_DADOS_FALTANTE } from '@constants/Text'
import {
  readRecentClients,
  shouldRestoreBootClient,
} from '@utils/restore-search-clients/restore-search-clients'
import { readSelectedGroupId } from '@modules/consolidator/utils/group-selection-storage/group-selection-storage'

/**
 * To call: store.dispatch('addSearchClient', {})
 * @param {Object} Client {name, id}
 */
const addSearchClient = ({ commit, state, dispatch, rootGetters }, client) => {
  const trocaDeContexto =
    client && client.id && rootGetters['consolidator/currentFamilyGroup']
  if (trocaDeContexto) {
    dispatch('consolidator/clearFamilyGroupSelection', null, { root: true })
  }
  commit('SET_CURRENT_CLIENT', client)
  commit('ADD_SEARCH_CLIENT', state.client)
}

const restoreSearchClients = ({ commit, dispatch, state }) => {
  const user = state.user || {}
  const clientes = readRecentClients(user)
  if (!clientes.length) return

  commit('ADD_LIST_SEARCH_CLIENT', clientes)
  const grupoPersistido = readSelectedGroupId(user.id)
  if (!shouldRestoreBootClient({ grupoPersistido })) return
  dispatch('addSearchClient', clientes[0])
}

const setCurrentUser = ({ commit, dispatch }, user) => {
  commit('SET_CURRENT_USER', user)
  dispatch('restoreSearchClients')
}

const setClients = ({ commit }, clients) => {
  commit('SET_CLIENTS', clients)
}

const setEmails = ({ commit }, emails) => {
  commit('SET_EMAILS', emails)
}

const setDatas = ({ commit }, datas) => {
  commit('SET_DATAS', datas)
}

const atualizarClientes = ({ commit }, clientes) => {
  if (Object.keys(clientes).length) {
    commit('UPDATE_CLIENTS', clientes)
  }
}

const checkIncompleteAsset = async ({ commit }) => {
  if (!store.getters['user/currentUser'].IS_CLIENTE) {
    return
  }
  const r = await con.get(minhaCarteira.cliente.posicao)
  if (r && typeof r.status === 'number' && r.status !== 200) {
    return
  }
  const has_incomplete =
    r &&
    Object.values(r).some((c) => {
      return JSON.parse(c.ativos).some((a) => {
        return (
          !!a.campos_faltantes &&
          !BLACK_LIST_DADOS_FALTANTE.includes(
            (a['Tipo'] || a['tipo']).toLowerCase()
          )
        )
      })
    })
  console.log('TEM INCOMPLETO: ', has_incomplete)
  commit('SET_INCOMPLETES_ASSETS', has_incomplete)
}

const setClientInfo = ({ commit }, info) => {
  commit('SET_CLIENT_INFO', info)
}

export const setLoadingUser = ({ commit }, loading) => {
  commit('SET_LOADING_USER', loading)
}

/**
 * Funcao para carregar todos os clientes da base
 */
const getAllClients = async ({ commit }) => {
  const r = await con.post(minhaCarteira.listar_clientes)
  if (r && Array.isArray(r.value)) {
    const clientes = r.value.map((c, index) => {
      if (!c.id) {
        c.id = (c.id_cadastro_cliente || index) * -1
      }
      return c
    })
    commit('SET_CLIENTS', clientes)
  }
}

const setAvatarUrl = ({ commit }, avatarUrl) => {
  commit('SET_AVATAR_URL', avatarUrl)
}

const updateClienteNome = ({ commit }, payload) => {
  commit('UPDATE_CLIENTE_NOME', payload)
}

// Insere/atualiza um cliente na lista global do filtro sem refetch da base.
// Usado no cadastro otimista de cliente (crm-add-client).
const upsertCliente = ({ commit }, payload) => {
  commit('UPSERT_CLIENTE', payload)
}

export {
  addSearchClient,
  restoreSearchClients,
  updateClienteNome,
  upsertCliente,
  setCurrentUser,
  setClients,
  setDatas,
  setEmails,
  atualizarClientes,
  checkIncompleteAsset,
  setClientInfo,
  getAllClients,
  setAvatarUrl,
}
